<template>
  <div class="banner">
    <!-- 图片 -->
    <div
      class="banner-slide"
      v-for="(item, index) in banners"
      :key="index"
      :class="{ active: index === current }"
    >
      <img :src="item.image" :alt="item.title" />
      <div class="banner-mask"></div>
      <!-- 文案
      <div class="banner-text">
        <h2>{{ item.title }}</h2>
        <p>{{ item.desc }}</p>
      </div> -->
    </div>
    <!-- 指示点 -->
    <div class="dots">
      <span
        v-for="(item, index) in banners"
        :key="index"
        :class="{ active: index === current }"
        @click="go(index)"
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeBanner',
  data() {
    return {
      current: 0,
      timer: null,
      banners: [
        {
          image: new URL('@/assets/images/banner/1.jpg', import.meta.url).href
        },
        {
          image: new URL('@/assets/images/banner/2.jpg', import.meta.url).href
        },
        {
          image: new URL('@/assets/images/banner/3.jpg', import.meta.url).href
        }
      ]
    }
  },
  mounted() {
    this.start()
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    start() {
      this.timer = setInterval(() => {
        this.current = (this.current + 1) % this.banners.length
      }, 5000)
    },
    go(index) {
      this.current = index
    }
  }
}
</script>
<!-- 引入外部 CSS -->
<style src="@/assets/styles/homebanner.css"></style>